export default __webpack_public_path__ + "static/volunteer-d6d9db7b6363f2ca775096e930110a69.png";